export const SET_BASE_PATH = 'SET_BASE_PATH';

export const SET_CUSTOMER_NAME = 'SET_CUSTOMER_NAME';

export const SET_FROM_EDITOR = 'SET_FROM_EDITOR';

export const SET_FROM_SURVEY = 'SET_FROM_SURVEY';

export const SET_SURVEY_ID = 'SET_SURVEY_ID';

export const SET_FROM_ORGANIZATION = 'SET_FROM_ORGANIZATION';

export const SET_ORGANIZATION_ID = 'SET_ORGANIZATION_ID';

export const REMOVE_PATH = 'REMOVE_PATH';

